import React, { useContext, useMemo } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Pen, PlusCircle, Trash } from 'react-bootstrap-icons';
import { LocalizeContext } from 'react-locale-language';
import { getTaxBracketFields } from '../../../helpers/constants';
import EntityTable from '../../common/EntityTable';
import { Button as ButtonTW } from '../../ui/button';
import { PenIcon, Trash2 } from 'lucide-react';

const TaxBrackets = ({
  buyingTaxBrackets = [],
  sellingTaxBrackets = [],
  buyingTaxBracketsForOnlyApartment = [],
  sellingTaxBracketsForOnlyApartment = [],
  onTaxBracketAddClick,
  onTaxBracketEditClick,
  onTaxBracketDeleteClick,
  readOnlyMode
}) => {
  const { translate, langCode } = useContext(LocalizeContext);
  const taxBracketHeaders = useMemo(() => getTaxBracketFields(translate), [langCode]);

  return (
    <Card className="mt-3">
      <Card.Header>{translate('tax_brackets')}</Card.Header>
      <Card.Body>
        <Row>
          {[
            { label: 'buying_tax_brackets', key: 'buyingTaxBrackets', data: buyingTaxBrackets },
            { label: 'selling_tax_brackets', key: 'sellingTaxBrackets', data: sellingTaxBrackets },
            {
              label: 'buying_tax_brackets_only_apartment',
              key: 'buyingTaxBracketsForOnlyApartment',
              data: buyingTaxBracketsForOnlyApartment
            },
            {
              label: 'selling_tax_brackets_only_apartment',
              key: 'sellingTaxBracketsForOnlyApartment',
              data: sellingTaxBracketsForOnlyApartment
            }
          ].map(({ label, key, data }) => (
            <Col key={key} xs={12} md={6} className="my-2">
              <EntityTable
                quickSearch={false}
                rowKeyField={'_id'}
                data={data}
                headers={taxBracketHeaders}
                searchQueryKeys={['from', 'to', 'percentage']}
                additionalComponents={() => (
                  <>
                    <b className="mx-3 mid">{translate(label)}:</b>
                    {!readOnlyMode && (
                      <Button
                        size="sm"
                        style={{ fontSize: 12 }}
                        className="text-white px-2 py-1"
                        variant="success"
                        onClick={() => onTaxBracketAddClick(key)}
                      >
                        <PlusCircle className="mx-1" size={10} /> {translate('new_tax_bracket')}
                      </Button>
                    )}
                  </>
                )}
                actionCell={item =>
                  !readOnlyMode && (
                    <div className="d-flex align-items-center  gap-2">
                      <ButtonTW
                        variant="ghost"
                        className="p-1 me-0 bg-transparent"
                        onClick={() => onTaxBracketEditClick(key, item)}
                      >
                        <PenIcon size={8} className="text-info" />
                      </ButtonTW>
                      <ButtonTW
                        variant="ghost"
                        className="p-1 me-0 bg-transparent"
                        onClick={() => {
                          onTaxBracketDeleteClick(key, item);
                        }}
                      >
                        <Trash2 size={8} className="text-red-500" />
                      </ButtonTW>
                    </div>
                  )
                }
              />
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TaxBrackets;
